import {useCurrentProject} from 'common/contexts/react/current-project-context';
import {ProjectFeatureFlag} from 'common/report/constants';
import {isPublicMode} from 'common/report/util';

/**
 * A hook that checks if a feature flag is enabled for the current project.
 *
 * @param flag - The feature flag to check.
 */
export function useFeatureFlag(flag: ProjectFeatureFlag) {
  const currentProject = useCurrentProject();

  /** guards against public boards not having project access */
  if (isPublicMode()) {
    return false;
  }

  return currentProject.get().value?.hasFeatureFlag(flag);
}
